import axios from 'axios'
import type { ApiError } from '@/models/auth'
import { ENV } from '../env.js'

/**
 * Single source of truth for the backend API base URL. Previously this line was
 * copy-pasted into every service file.
 */
export const API_URL = (ENV.backendUrl ?? 'http://localhost:4000') + '/api'

/**
 * Normalizes an axios error into the app's `ApiError` shape. Use in service
 * catch blocks instead of re-writing the same `isAxiosError` / `response.data`
 * unwrap each time:
 *
 *   try { ... } catch (error) {
 *     throw toApiError(error, 'An unexpected error occurred while fetching invoices')
 *   }
 */
export function toApiError(error: unknown, fallbackMessage: string): ApiError {
  if (axios.isAxiosError(error) && error.response) {
    return error.response.data as ApiError
  }
  return { error: fallbackMessage }
}
